<template>
    <div class="type-section" :style="`width: ${styles.width}`">
        <div class="flex-x-center">
            <span class="m-no-margin-l number">{{ types.level }}</span>
            <div class="span">
                <CountBar
                    :id="ID().countBar"
                    :count="types.names.length"
                    :contentInitiated="contentInitiated"
                />
                <Names
                    :id="ID().names"
                    :names="types.names"
                    :primary="types.level === 1"
                    :contentInitiated="contentInitiated"
                    @content-initiated="$emit('content-initiated', $event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Names from "@/components/Projects/Project/Detail/Types/Names.vue";
import CountBar from "@/components/Projects/Project/Detail/Types/CountBar.vue";
import { projectModel } from "@/models";

export default {
    name: "ProjectDetailTypesSection",
    props: {
        types: Object,
        totalLevels: Number,
        contentInitiated: Boolean,
        mobile: Boolean
    },
    components: {
        Names,
        CountBar
    },
    data: () => ({ styles: { width: "" } }),
    methods: {
        ID: function() {
            const { level } = this.types;
            const countBarID = `count-bar-${level}`;
            const namesID = `type-names-${level}`;
            return {
                countBar: !this.mobile ? countBarID : `m-${countBarID}`,
                names: !this.mobile ? namesID : `m-${namesID}`
            };
        }
    },
    beforeMount: function() {
        this.styles.width = !this.mobile ? `${100 / this.totalLevels}%` : `${100}%`;
    },
    emits: [ ...projectModel.emits ]
};
</script>